const persistDataLocally = store => next => action => {
    next(action);
    localStorage['reduxStore'] = JSON.stringify(store.getState());
}
  
export default persistDataLocally;


// WEBPACK FOOTER //
// ./src/middleware/persist-data-locally.js